module.exports = {"address":[{"contact":"Robakidze Str. 3/5 #44"},{"contact":"Tbilisi 0159 Georgia"},{"contact":"Tel: +995 322 520229"},{"contact":"Mob:+995 599 918717"},{"contact":"E-mail: bakar@horsesport.ge"}],"secGeneral":[{"name1":"Bakar Gachechiladze"},{"name1":"Secretary General"},{"name1":"Georgian Equestrian Federation"}],"president":[{"presidentName":"Lasha Jaiani"},{"presidentName":"President"}],"vicPres":[{"vicPresName":"Zaza Chitrekashvili"},{"vicPresName":"Vice-President"}]}


//////////////////
// WEBPACK FOOTER
// ./src/components/EN-vers/menu/AboutUsJSON/en-AboutUs.json
// module id = fBTO
// module chunks = 0